'use strict';
var host = location.hostname;

function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function sendRecData(el) {
    var prods = el.classList.contains('slick-component') ? el.querySelectorAll('.slick-slide:not(.slick-cloned) .slider-item') : el.querySelectorAll('.rec-grid-item');
    
    var prodList = [];

    prods.forEach(function(prod) {
        var newItem = { ID: prod.getAttribute('data-prodid')};
        prodList.push(newItem);
    });
    const data = {
        recommenderName: el.getAttribute('data-reco'),
        products: prodList
    };
    

    fetch('/on/demandware.store/Sites-rawlings-consolidated-Site/default/Recommendations-RegisterActivity?activityName=viewRecommendation&data=' + JSON.stringify(data))
      .then(response => console.log(response.json()))
      .then(data => console.log(data));
}

function sendClickActivity(element) {
    const recName = element.closest('.pd-rec-component').getAttribute('data-reco');

    const data = {
        recommenderName: recName,
        product: {
            ID: element.getAttribute('data-prodid') 
        }
    };

    fetch('/on/demandware.store/Sites-rawlings-consolidated-Site/default/Recommendations-RegisterActivity?activityName=clickRecommendation&data=' + JSON.stringify(data))
      .then(response => console.log(response.json()))
      .then(data => console.log(data));
}



module.exports = function () {
    
    //When recommender grid/sldier is in view send Einstein view activity
    document.addEventListener('scroll', function () {
          
        [...document.querySelectorAll('.pd-rec-component:not(.rec-viewed)')].forEach(function(e) {
            if (isInViewport(e)) {
                sendRecData(e);
                e.classList.add('rec-viewed');
            }
        });

    }, {
        passive: true
    });
    
    //Add click listener to all einstein products on the page
    var einElements = document.querySelectorAll('.pd-rec-component .slick-slide:not(.slick-cloned) .slider-item, .rec-grid-item');

    einElements.forEach(el => el.addEventListener('click', event => {
        sendClickActivity(el);
    }));

};
